import React, { useState } from "react";
import MainHeader from "../NewOTTFIles/MainHeader";
import MainSidebar from "../NewOTTFIles/MainSidebar";
import Footer from "./Footer";
import MainContentPage from "../NewOTTFIles/MainContentPage";
import ShortVideo from "../Shorts Videos/ShortVideo";
import WatchHistory from "../Pages/WatchHistory";
import MyList from "../Pages/MyList";
import LinkDevice from "../Pages/LinkDevice";
import UserAccount from "../Pages/UserAccount";
import HelpPage from "../Pages/HelpPage";
import SearchPage from "../Pages/SearchPage";
import FilterPage from "../Pages/FilterPage";
import NewRelease from "../Pages/NewRelease";

const MainPanel = ({path}) => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  const toggleCollpased = () => {
    setIsCollapsed(!isCollapsed);
  };
  return (
    <>
      <MainHeader />
      <div className="d-flex">
        <div
          style={{ width: isCollapsed ? "8%" : "15%", backgroundColor: "#1e293b" }}
          className={isCollapsed ? "smoothCollapse" : "smoothCollapse"}
        >
          <MainSidebar
            path={path}
            isCollapsed={isCollapsed}
            setIsCollapsed={setIsCollapsed}
            toggleCollpased={toggleCollpased}
          />
        </div>
        <div
          style={{ width: isCollapsed ? "92%" : "85%" }}
          className={isCollapsed ? "smoothCollapse1" : "smoothCollapse1"}
        >
          {path === "/" ? (
            <MainContentPage />
          ) : path === "/home" ? (
            <MainContentPage />
          ) : path === "/shortVideo" ? (
            <ShortVideo />
          ) : path === "/watchHistory" ? (
            <WatchHistory />
          ) : path === "/myList" ? (
            <MyList />
          ) : path === "/activateTV" ? (
            <LinkDevice />
          ) : path === "/myAccount" ? (
            <UserAccount />
          ) : path === "/help" ? (
            <HelpPage />
          ) : path === "/notification" ? (
            <NewRelease />
          ) : path === "/search" ? (
            <SearchPage />
          ) : path === "/categories" ? (
            <FilterPage />
          ) : null}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default MainPanel;
